import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../i18n/I18nContext';
import { sectionsFor } from '../help/guideContent';

// Route -> guide section (operator/manager variants where the page means different things).
const ROUTE_SECTION = {
  '/': 'live', '/operator-terminal': 'terminal', '/machine-logs': 'terminal', '/problems': 'problems',
  '/scheduling': ['production', 'scheduling'], '/materials': ['material', 'inventory'], '/material-schedule': 'inventory',
  '/assignments': 'assign', '/machines': 'assign', '/reports': 'reports', '/problem-report': 'reports',
  '/leaderboard': 'awards', '/my-awards': 'awards', '/users': 'users', '/manage-awards': 'giveAwards',
  '/audit': 'audit', '/settings': 'settings', '/notifications': 'notify',
};

// Small "?" that opens the matching part of the Help guide for the current page.
export function PageHelpButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useI18n();
  const entry = ROUTE_SECTION[pathname];
  if (!entry || !user) return null;
  const isMgr = user.role === 'ADMIN' || user.role === 'SUPERVISOR';
  const wanted = Array.isArray(entry) ? entry[isMgr ? 1 : 0] : entry;
  const allowed = sectionsFor(user.role).some((s) => s.id === wanted);
  const target = allowed ? wanted : 'start';
  return (
    <button onClick={() => navigate(`/help#guide-${target}`)} title={t('help.pageHelp')} aria-label={t('help.pageHelp')}
      className="w-7 h-7 rounded-full flex items-center justify-center shrink-0 transition-colors hover:bg-[rgba(212,175,55,0.15)]"
      style={{ border: '1px solid var(--kmt-border)', color: 'var(--kmt-gold)' }} data-testid="page-help-btn">
      <HelpCircle size={15} />
    </button>
  );
}
